export const separatorStyles = {
  borderBottom: 'token(borderWidths.thin) solid',
  borderColor: 'border.weak',
  _last: { borderBottom: 'none' },
} as const;
